import React, { useRef } from 'react';
import useScrollScrub from '../hooks/useScrollScrub';
import './ScrollRevealText.css';

// Renders `text` word by word, brightening each word in sequence as the
// element scrolls through the viewport (scroll-scrubbed, not one-shot).
const ScrollRevealText = ({ text, className = '' }) => {
  const ref = useRef(null);
  useScrollScrub(ref);
  const words = text.split(' ');

  return (
    <p
      ref={ref}
      className={`scroll-reveal-text ${className}`.trim()}
      style={{ '--total': words.length }}
    >
      {words.map((word, i) => (
        <span key={i} style={{ '--i': i }}>{word}{' '}</span>
      ))}
    </p>
  );
};

export default ScrollRevealText;
